import { Env } from '../../../sites/types';

export const isDevelopmentEnv = (env: Env) => env.STAGE === 'development';
